import { useState } from 'react';

import { NestedLocation } from '../../../types/nestedLocations';
import { cn } from '../../../utils/utils';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '../../shadcn-ui/dropdown-menu';
import { LocationSelectorDropdownContent } from './LocationSelectorDropdownContent';
import { LocationSelectorTrigger } from './LocationSelectorTrigger';
import { LocationsState } from './LocationsSelectorReducer';

interface NestedLocationSelectorProps {
  state: LocationsState;
  onSelectLocation: (locationId: number, locationType: 'NestableLocation' | 'Location') => void;
  allowedNestableLocations?: NestedLocation[];
  multipleSelection?: boolean;
  showLegacyLocations?: boolean;
  showSearch?: boolean;
  searchPlaceholder?: string;
  triggerPlaceholder?: string;
  contentClassName?: string;
  triggerClassName?: string;
  locationsBlacklist?: number[];
  disabled?: boolean;
  customTrigger?: React.ReactNode;
  maxSelectableDepth?: number;
  prefixBadge?: string;
  /** Applied to the default trigger button so agent-browser can target the picker. */
  dataTestId?: string;
}

const NestedLocationSelector = ({
  state,
  onSelectLocation,
  allowedNestableLocations,
  multipleSelection = false,
  showLegacyLocations = false,
  showSearch = true,
  searchPlaceholder,
  triggerPlaceholder,
  contentClassName,
  triggerClassName,
  disabled,
  locationsBlacklist,
  customTrigger,
  maxSelectableDepth,
  prefixBadge,
  dataTestId,
}: NestedLocationSelectorProps) => {
  const [open, setOpen] = useState(false);
  const { selectedLocations, legacySelectedLocations } = state;

  return (
    <DropdownMenu
      open={open}
      onOpenChange={setOpen}
    >
      <DropdownMenuTrigger
        disabled={disabled}
        asChild
      >
        {customTrigger ? (
          customTrigger
        ) : (
          <LocationSelectorTrigger
            selectedLocations={selectedLocations}
            legacySelectedLocations={legacySelectedLocations}
            multipleSelection={multipleSelection}
            triggerPlaceholder={triggerPlaceholder}
            triggerClassName={triggerClassName}
            disabled={disabled}
            onSelectLocation={onSelectLocation}
            prefixBadge={prefixBadge}
            data-testid={dataTestId}
          />
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align='start'
        className={cn(
          'bg-white w-[var(--radix-dropdown-menu-trigger-width)] max-h-[50vh] z-[2000]',
          contentClassName,
        )}
      >
        <LocationSelectorDropdownContent
          state={state}
          onSelectLocation={onSelectLocation}
          allowedNestableLocations={allowedNestableLocations}
          multipleSelection={multipleSelection}
          showLegacyLocations={showLegacyLocations}
          showSearch={showSearch}
          searchPlaceholder={searchPlaceholder}
          locationsBlacklist={locationsBlacklist}
          maxSelectableDepth={maxSelectableDepth}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NestedLocationSelector;
